import { LOGIN_REQUEST, LOGOUT, REFRESH_TOKEN_REQUEST } from "./constants";

export function login(data: any) {
  return {
    type: LOGIN_REQUEST,
    payload: {
      method: "POST",
      url: "/auth/login",
      data,
    },
  };
}

export function logout() {
  return {
    type: LOGOUT,
  };
}

export function refresh(refreshToken: string) {
  return {
    type: REFRESH_TOKEN_REQUEST,
    payload: {
      method: "POST",
      url: "/auth/refresh",
      data: { refresh: refreshToken },
    },
  };
}
